import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP9BudgetCappedNew202512: FaireAdPerformancePeriodEntity = {
  token: "perf_p9_budget_capped_new_202512",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-12-01",
  endDate: "2025-12-31",
  impressions: 27109,
  clicks: 476,
  adsSpendDollars: 1252,
  budgetDollars: 4000,
  salesDollars: 6700,
  bestEstimateRoas: 5.35,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.31,
  newCustomersAcquired: 16,
  dataAvailableAtDate: "2026-01-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
